var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCard(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1.8002 5.99531C1.8002 5.33257 2.33745 4.79531 3.0002 4.79531H21.0002C21.6629 4.79531 22.2002 5.33257 22.2002 5.99531V9.19531H1.8002V5.99531ZM0.200195 9.99531V5.99531C0.200195 4.44892 1.4538 3.19531 3.0002 3.19531H21.0002C22.5466 3.19531 23.8002 4.44892 23.8002 5.99531V9.99531V17.9953C23.8002 19.5417 22.5466 20.7953 21.0002 20.7953H3.0002C1.4538 20.7953 0.200195 19.5417 0.200195 17.9953V9.99531ZM22.2002 10.7953V17.9953C22.2002 18.6581 21.6629 19.1953 21.0002 19.1953H3.0002C2.33745 19.1953 1.8002 18.6581 1.8002 17.9953V10.7953H22.2002Z",
    fill: "#4D4D4D"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCard);
export default __webpack_public_path__ + "static/media/card.11b63843fecea446ae19f60e1526203b.svg";
export { ForwardRef as ReactComponent };